import { memo } from 'react'

import {
  SkeletonLine,
  SkeletonSquare
} from 'shared/ui/Skeleton/SkeletonPrimitives'

import { SEARCH_QUERY_INSTANT_RESULTS_DISPLAY_COUNT } from '../../config'

import styles from './SearchProductsResultsSkeleton.module.scss'

const SearchProductsResultsSkeleton = () => (
  <>
    {Array.from({ length: SEARCH_QUERY_INSTANT_RESULTS_DISPLAY_COUNT }).map(
      (_, i) => (
        <li className={styles.searchProductCardWrapper} key={i} aria-hidden='true'>
          <div className={styles.row}>
            <div className={styles.imageWrapper}>
              <div className={styles.mobileContent}>
                <SkeletonSquare size={64} />
              </div>
              <div className={styles.tabletAndWebContent}>
                <SkeletonSquare size={80} />
              </div>
            </div>
            <div className={styles.details}>
              <SkeletonLine w='80px' h='12px' />
              <SkeletonLine w='60%' h='12px' />
              <SkeletonLine w='60px' h='12px' />
              <SkeletonLine w='32px' h='12px' />
            </div>
            <div className={styles.right}>
              <SkeletonSquare size={40} />
            </div>
          </div>
        </li>
      )
    )}
  </>
)

export default memo(SearchProductsResultsSkeleton)
